import moment from "moment";

moment.updateLocale("en", {
  relativeTime: {
    future: "In %s",
    past: "%s ago",
    s: "seconds",
    ss: "%ss",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1 day",
    dd: "%d days",
    M: "1 month",
    MM: "%d months",
    y: "1Y",
    yy: "%dY",
  },
});
